module.exports = __webpack_public_path__ + "static/end-8b8e0ad47705ae7a67211166a6fde593.png";